import React from "react";
import "./cardPeque.css";

export const CardPeque = ({ title, cover }) => {

    return (
        <div className="cardPeque">
            <div className="cardPeque-content">
                <div className="cardPeque-name">{title}</div>
                <div className="cardPeque-stars">★★★★★</div>
            </div>
        </div>
    );
};
